<template>
  <vue-scroll>
  <div class="project-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="名称" prop="name">
                  <Input v-model="filterModel.name" placeholder="输入名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="项目立项备案号" prop="filingNo">
                  <Input v-model="filterModel.filingNo" placeholder="输入项目立项备案号" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="规划许可证号" prop="planLicenseNo">
                  <Input v-model="filterModel.planLicenseNo" placeholder="输入建设工程规划许可证号" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="施工许可证号" prop="constrLicenceNo">
                  <Input v-model="filterModel.constrLicenceNo" placeholder="输入施工许可证号" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="工程所在地" prop="cityCode">
                  <Input v-model="filterModel.cityCode" placeholder="输入工程所在地" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="造价范围" prop="costStart">
                  <InputNumber :min="0" :step="10000" style="width: 100px" v-model="filterModel.costStart" placeholder="从(元)"></InputNumber>
                  -
                  <InputNumber :min="0" :step="10000" style="width: 100px" v-model="filterModel.costEnd" placeholder="到(元)"></InputNumber>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem label="类别" prop="type" style="width: 100%">
                  <Cascader :data="prjTypeSelect" change-on-select v-if="prjTypeSelect&&prjTypeSelect.length"  @on-change="prjTypeFilterSelected" placeholder="选择"></Cascader>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/projects/new" icon="md-add">新增项目</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'project-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '工程所在地',
          key: 'cityName',
          resizable: true,
          width: 140,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '类型',
          key: 'type',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            let typeName = params.row.prjType
            let t = this.prjTypes.find(o => o.tid === params.row.type)
            if (t) {
              typeName = t.prjType
            }
            return h('span', null, typeName)
          }
        },
        {
          title: '造价(万)',
          key: 'cost',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.cost ? Math.round(params.row.cost / 100 / 1000) / 10 : null)
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '查看保函',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-clipboard'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'guarantee-list', query: {prjId: params.row.id}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'project-detail', params: {projectId: params.row.id}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'project-edit', params: {project: params.row}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let projectId = params.row.id
                      this.deleteProject(projectId)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        type: null,
        filingNo: null,
        planLicenseNo: null,
        constrLicenceNo: null,
        cityCode: null,
        costStart: null,
        costEnd: null,
        startDateFrom: null,
        startDateTo: null,
        finishDateTo: null,
        finishDateFrom: null
      },
      departments: [],
      curDepartmentId: null,
      prjTypes: [],
      prjTypeSelect: null
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
    this.initPrjTypes().then((list) => {
      this.prjTypeSelect = this.prepPrjTypeCascader(list)
    })
    window.less.modifyVars({
      '@primaryColor': '#ff9900'
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Project.listProjects(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteProject (projectId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该项目么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Project.deleteProject(projectId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.id === projectId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    prepPrjTypeCascader (list) {
      let data = []
      let topTier = list.filter(o => {
        return o.parentNode === null
        })
      topTier.forEach((t1) => {
        let tierId = t1.tid
        if (!t1.children) {
          t1.children = [{
            label: '本级',
            value: t1.tid
          }]
        }
        let secondTier = list.filter(o => {
          return o.parentNode === tierId
        })
        secondTier.forEach((t2) => {
          t1.children.push({
            label: t2.prjType,
            value: t2.tid,
            tid: t2.tid
          })
        })
        data.push({
          label: t1.prjType,
          value: t1.tid,
          tid: t1.tid,
          children: t1.children
        })
      })
      return data
    },
    prjTypeFilterSelected (val) {
      if (val instanceof Array) {
        this.filterModel.type = val[val.length - 1]
      } else {
        this.filterModel.type = val
      }
    }
  }
}
</script>

<style lang="less" scoped>
.project-list {
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
